var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { selectOutskirtDisplayLevelById } from "../../selectors/selectOutskirtBuildingUpgradeInfo";
import { OutskirtBuilding, } from "./OutskirtBuilding";
var OutskirtBuildingWithLevel = /** @class */ (function (_super) {
    __extends(OutskirtBuildingWithLevel, _super);
    function OutskirtBuildingWithLevel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mapState = function (state) {
            var baseState = _this.baseMapState(state);
            if (baseState.isAccessible) {
                baseState.stage = selectOutskirtDisplayLevelById(state, _this.outskirtId) || 1;
            }
            return baseState;
        };
        _this.update = function (props) {
            _this.baseUpdate(props);
            if (props.isAccessible && props.stage) {
                _this.stage = props.stage;
            }
        };
        return _this;
    }
    return OutskirtBuildingWithLevel;
}(OutskirtBuilding));
export { OutskirtBuildingWithLevel };



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/OutskirtBuildingWithLevel.ts
// module id = 427
// module chunks = 3